var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7549_2458)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8333 6.33365H10.8333C9.74483 6.33365 8.81881 7.02932 8.47561 8.00031H9.16667C11.1825 8.00031 12.8639 9.43178 13.25 11.3337H15.8333C17.2141 11.3337 18.3333 10.2144 18.3333 8.83365C18.3333 7.45294 17.2141 6.33365 15.8333 6.33365ZM11.5244 11.3337H10.8333C10.0929 11.3337 9.42769 11.0118 8.96992 10.5003H7.01338C7.65635 11.9719 9.12475 13.0003 10.8333 13.0003H15.8333C18.1345 13.0003 20 11.1348 20 8.83365C20 6.53246 18.1345 4.66698 15.8333 4.66698H10.8333C8.81755 4.66698 7.13609 6.09844 6.75003 8.00031H4.16667C1.86548 8.00031 0 9.86579 0 12.167C0 14.4682 1.86548 16.3336 4.16667 16.3336H9.16667C10.8753 16.3336 12.3437 15.3052 12.9866 13.8336H11.0301C10.5723 14.3451 9.90708 14.667 9.16667 14.667H4.16667C2.78595 14.667 1.66667 13.5477 1.66667 12.167C1.66667 10.7863 2.78595 9.66697 4.16667 9.66697H6.75003C6.75003 9.66698 6.75003 9.66698 6.75003 9.66698H8.4756C8.4756 9.66698 8.4756 9.66698 8.4756 9.66697H9.16667C10.2552 9.66697 11.1812 10.3627 11.5244 11.3337Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7549_2458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(0 0.500305)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.7d2f971544920af6b7141ebcb5072ddf.svg";
export { ForwardRef as ReactComponent };